const isJsonString = str => {
	try {
		if (typeof JSON.parse(str) === "object") {
			return true
		}
	} catch (e) { return false }
	return false
}


const msgTypes = {}
var messages = {}

const wsWithTokenInner = obj => {
	// this.reConnectTimes = 0
	// this.handlerUrl = obj && obj.handlerUrl
	var socket = undefined
	var closing = undefined
	var isReconnect = false
	// this.callBack = obj && obj.callBack
	var connected = false

	const onopen = e => {
		connected = true
		// console.log('on open:', e)
	}

	const onmessage = e => {
		if (isJsonString(e.data)) {
			const newMessages = JSON.parse(e.data)
			//执行回调
			Object.entries(newMessages).forEach(([key, value]) => {
				const cbs = msgTypes[key] || []
				cbs.forEach(cb => cb(value))
			})
			messages = { ...messages, ...newMessages }
			// this.callBack(message)
		} else {
			//console.log(e.data)
		}
		// console.log('onmessage:', e)
	}

	const onerror = e => {
		// if (this.reConnectTimes >= 10) {
		// 	return
		// }
		connected = false
		// this.reConnectTimes += 1
		reConnect()
		console.error('onerror:', e)
	}

	const onclose = e => {
		connected = false
		socket = undefined

		// console.log('onclose:', e)

		if (closing) {
			closing = undefined
			return
		}

		reConnect()
		//console.log(e.data)
	}

	//初始化websocket连接 
	const initWs = () => {
		if (Tyan.appSettings.useMockData || Tyan.appSettings.noWebsocketWithToken)
			return

		const webSocket = window.WebSocket || window.MozWebSocket
		if (!webSocket) {
			console.error('该浏览器不支持websocket')
			return
		}
		const fetchPath = Tyan.appSettings.fetchPath
		const handlerUrl = `ws${fetchPath.toLowerCase().startsWith('http') ? `${fetchPath.substring(4)}` : `${location.protocol.substring(4)}//${location.host}${fetchPath.startsWith('/') ? '' : location.pathname.substring(0, location.pathname.lastIndexOf('/') + 1)}${fetchPath}`}/GetTokenConnect`
		const token = obj && obj.token

		// 无handlerUrl 或 无token 直接返回
		if (!handlerUrl || !token)
			return

		//Internet选项->安全->本地Internet->站点 没有添加的时候会报错，针对不安装控件的客户加了try
		try {
			socket = new WebSocket(handlerUrl + "?token=" + token)
			socket.onopen = onopen
			socket.onmessage = onmessage
			socket.onclose = onclose
			socket.onerror = onerror
		} catch (e) { }

		messages = {}
		// setTimeout(() => {
		// 	console.log('break')
		// 	sendMsg({ action: 'break' })
		// }, 5000)
	}

	//重新连接
	const reConnect = () => {
		if (isReconnect) return
		isReconnect = true
		setTimeout(() => {
			initWs()
			isReconnect = false
		}, 5000)
	}

	const close = () => {
		socket && (closing = true, socket.close(), socket = null)
	}

	const sendMsg = obj => {
		// console.log('send msg:', obj, socket)
		socket && socket.send(JSON.stringify(obj))
	}

	//初始化websocket连接    
	initWs()

	return { close, sendMsg }
}

const wsWithToken = (() => {
	let wsClient

	/**
	 * 
	 * @param {*} key : 可用类型:'tasks', 
	 * @param {*} cb 
	 */
	const register = (key, cb) => {
		const cbs = msgTypes[key] = msgTypes[key] || []
		!cbs.find(val => val === cb) && cbs.push(cb)
		// 如已有数据则调用
		messages[key] !== undefined && cb(messages[key])
	}

	const unregister = (key, cb) => {
		const cbs = msgTypes[key]
		const index = cbs ? cbs.findIndex(val => val === cb) : -1
		index >= 0 && cbs.splice(index, 1)
	}

	const disConnect = () => { wsClient && (wsClient.close(), wsClient = undefined) }
	const sendMsg = obj => wsClient & wsClient.sendMsg(obj)
	const connect = obj => {
		disConnect()
		wsClient = wsWithTokenInner(obj)
	}

	return { connect, disConnect, sendMsg, register, unregister }
})()

export default wsWithToken